module.exports = __webpack_public_path__ + "img/Demetrios.24124c53.png";